import React from "react";
import { House, Wrench, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Whole or Partial House Remodels",
  description: "Transform your living space with our comprehensive remodeling services. From concept to completion, we deliver high-quality craftsmanship that breathes new life into your home.",
  icon: House,
  href: "#remodels"
}, {
  title: "Handyman Work",
  description: "Reliable fixes for your everyday home maintenance needs. Our skilled team handles repairs efficiently, ensuring your property remains safe, functional, and in top condition.",
  icon: Wrench,
  href: "#handyman"
}];
export default function OurExpertisePillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-expertise-pillars" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => <Card key={i} data-index={i} className="bg-card border border-border/50 hover:border-primary/50 transition-colors duration-300 flex flex-col h-full">
              <CardHeader className="pb-4">
                <div className="mb-6 inline-flex items-center justify-center size-16 rounded-2xl bg-primary/10 text-primary">
                  <service.icon className="size-8" strokeWidth={1.5} />
                </div>
                <CardTitle className="font-sans font-bold text-2xl tracking-tight">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardContent>
              <CardFooter className="pt-4">
                <Link to={service.href} className="group inline-flex items-center text-primary font-medium text-sm hover:text-primary/80 transition-colors">
                  Learn More
                  <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}